import * as React from 'react'

import {IFeatureLayerInfo} from '../../core/interfaces/models'
import {connect} from 'react-redux'
import {IAppStore, IAppUser} from '../../interfaces/reducers'
import appConfig from '../../reducers/appConfig'
import OverlayLoader from '../../core/components/Loading/OverlayLoading'
import {createNewFeature} from '../../core/helpers'
import {
  IMapDispatcher,
  IEditsDispatcher,
  IGeometryEditsDispatcher,
  IPopupDispatcher
} from '../../core/interfaces/dispatchers'
import {appMapDispatcher} from '../../dispatchers/appMapDispatcher'
import EditFeatureDispatcher from './EditFeatureDispatcher'
import {Feature} from '../../core/models'
import {appEditsDispatcher} from '../../dispatchers/appEditsDispatcher'
import {appGeometryEditsDispatcher} from '../../dispatchers/appGeometryEditsDispatcher'
import {appPopupDispatcher} from '../../dispatchers/appPopupDispatcher'
import {getMapService} from '../../core/reducers/map'

interface OwnProps {
  layerInfos: {[id: string]: IFeatureLayerInfo}
}

interface DispatchProps extends IMapDispatcher, IEditsDispatcher, IGeometryEditsDispatcher, IPopupDispatcher {}

interface ParentProps {
  layerId: string
  feature?: Feature
  style?: React.CSSProperties
  onFeatureChanged?: (feature: Feature) => void
  buttonsClassname?: string
  onAfterSave?: (feature: Feature) => void
  saveControlsTop?: boolean
  onCancel?: (feature: Feature) => void
  onAfterDelete?: () => void
  hideCancel?: boolean
  hideDelete?: boolean
  hideSave?: boolean
  user?: IAppUser
  editAgain: (feature: Feature) => Feature
  map?: JSX.Element
}

type Props = OwnProps & DispatchProps & ParentProps

interface State {}

class EditFeatureDispatcherContainer extends React.Component<Props, State> {
  createNewFeature(layerInfo: IFeatureLayerInfo): Feature {
    const newFeature = createNewFeature(layerInfo)
    // here you can specify default props for specific layers
    return newFeature
  }

  render() {
    const layerInfo = this.props.layerInfos[this.props.layerId]
    if (layerInfo) {
      const feature = this.props.feature ? this.props.feature : this.createNewFeature(layerInfo)
      return (
        <EditFeatureDispatcher
          map={this.props.map}
          editAgain={this.props.editAgain}
          layerInfo={layerInfo}
          feature={feature}
          editsDispatcher={this.props}
          popupDispatcher={this.props}
          geometryEditsDispatcher={this.props}
          user={this.props.user}
          //Parents know better:
          onAfterSave={f => {
            for (const l in this.props.layerInfos) {
              if (appConfig.reg.matrixZone.ids.indexOf(l) != -1) {
                this.props.layerInfos[l].refresh()
              }
            }
            if (appConfig.reg.site.id == layerInfo.sourceDescription.id) {
              this.props.layerInfos[appConfig.reg.siteLine.id].refresh()
            }
            if (appConfig.reg.siteLine.id == layerInfo.sourceDescription.id) {
              this.props.layerInfos[appConfig.reg.site.id].refresh()
            }
            if (this.props.onAfterSave) {
              this.props.onAfterSave(f)
            }
          }}
          onCancel={this.props.onCancel}
          onAfterDelete={() => {
            for (const l in this.props.layerInfos) {
              if (appConfig.reg.matrixZone.ids.indexOf(l) != -1) {
                this.props.layerInfos[l].refresh()
              }
            }
            if (appConfig.reg.site.id == layerInfo.sourceDescription.id) {
              this.props.layerInfos[appConfig.reg.siteLine.id].refresh()
              getMapService()
                .getLayers()
                .filter(l => l.moreInfo.urls.indexOf(appConfig.reg.site.id) != -1)
                .forEach(l => {
                  l.setOpacity(0)
                })
              getMapService()
                .getLayers()
                .filter(l => l.moreInfo.urls.indexOf(appConfig.reg.siteLine.id) != -1)
                .forEach(l => {
                  l.setOpacity(1)
                })
            }
            if (appConfig.reg.siteLine.id == layerInfo.sourceDescription.id) {
              this.props.layerInfos[appConfig.reg.site.id].refresh()
            }
            if (this.props.onAfterDelete) {
              this.props.onAfterDelete()
            }
          }}
          saveControlsTop={this.props.saveControlsTop}
          hideCancel={this.props.hideCancel}
          hideDelete={this.props.hideDelete}
          hideSave={this.props.hideSave}
          buttonsClassname={this.props.buttonsClassname}
          style={this.props.style}
        />
      )
    } else {
      return (
        <div style={{width: '100%', height: '100%', position: 'relative'}}>
          <OverlayLoader />
        </div>
      )
    }
  }
}

const mapStateToProps = (state: IAppStore) => ({
  layerInfos: state.layerInfos.featureLayerInfos
})

export default connect<OwnProps, DispatchProps, ParentProps>(mapStateToProps, {
  ...appMapDispatcher,
  ...appEditsDispatcher,
  ...appGeometryEditsDispatcher,
  ...appPopupDispatcher
})(EditFeatureDispatcherContainer)
